import {DateTime} from "luxon";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class TimelineJumpToDateCommand extends AbstractCommand<DateTime> {

    public name: CommandName = CommandName.TIMELINE_JUMP_TO_DATE;

    public tags = ['ui', 'timeline', 'navigation'];

    constructor(targetDate: DateTime) {
        super('timeline', 'system', targetDate);
    }
}